import { FC, useMemo } from "react";
// 组件
import { DeleteOutlined } from '@ant-design/icons';
import { ProTable } from '../../../antd';
import { DndContext, DragEndEvent } from '@dnd-kit/core';
import MoveTransferTableRow from "./moveTransferTableRow";
// 方法
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
// 常量
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { STATUS_CREATED, STATUS_CREATED_CODE, } from '../../../constants/constant';
import { RightTableProps, SORT_DATAINDEX } from "../../interface";
import { ColumnsType } from "antd/lib/table";
import styles from './style.module.less';

const RightTable: FC<RightTableProps> = props => {
  const {
    dataSource, columns: outColumns, rowKey, width, height, selectedDataSource = [], isMoveSort,
    onDelete, onDragEnd,
  } = props;
  const handleDragEnd = ({ active, over }: DragEndEvent) => {
    if (!active || !over) return;
    const startKey = active.id as string;
    const endKey = over.id as string;
    if (startKey === endKey) return;
    onDragEnd(startKey, endKey);
  };
  /** 过滤删除数据 */
  const effectiveDataSource = useMemo(() => {
    return selectedDataSource.filter(item => item[STATUS_CREATED_CODE] !== STATUS_CREATED.DELETE);
  }, [selectedDataSource]);
  /** 列配置 */
  const columns: ColumnsType<any> = useMemo(() => {
    const newColumns: ColumnsType<any> = [];
    outColumns?.forEach(item => {
      newColumns.push({
        ...item,
        ellipsis: true,
      });
    });
    newColumns.push({
      title: '操作',
      align: 'center',
      width: 60,
      fixed: 'right',
      render: (record) => {
        return (
          <DeleteOutlined
            className={styles.delete}
            onClick={() => onDelete(record.key)}
          />
        );
      },
    });
    if (isMoveSort) {
      newColumns.unshift({
        dataIndex: SORT_DATAINDEX,
        width: 60,
        align: 'center',
        fixed: 'left',
      });
    }
    return newColumns;
  }, [outColumns, selectedDataSource, isMoveSort]);
  const tableNode = (
    <ProTable
      size="small"
      rowKey={rowKey}
      dataSource={dataSource}
      columns={columns}
      pagination={false}
      components={isMoveSort ? {
        body: {
          row: MoveTransferTableRow,
        },
      } : undefined}
      // @ts-ignore
      onRow={isMoveSort ? (_, index) => {
        return {
          index,
        };
      } : undefined}
      scroll={{
        x: width ? width : 'max-content',
        y: height,
      }}
    />
  );

  return isMoveSort ? (
    <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={handleDragEnd}>
      <SortableContext
        items={effectiveDataSource.map(item => item.key)}
        strategy={verticalListSortingStrategy}
      >
        {tableNode}
      </SortableContext>
    </DndContext>
  ) : tableNode;
};

export default RightTable;
